import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Slide,
  Box,
} from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import { forwardRef } from "react";

// Slide transition
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export default function TransferSuccessDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="transfer-success-description"
    >
      <Box sx={{ textAlign: "center", p: 3 }}>
        <Box
          sx={{
            width: "50px",
            height: "50px",
            background: "white",
            mx: "auto",
            objectFit: "contain",
            mb: 2,
          }}
        >
          <img
            src="/images/subscription.gif"
            alt=""
            width={"100%"}
            style={{ display: "block", margin: "0 auto" }}
          />
        </Box>
        <DialogTitle>Transfer Successful!</DialogTitle>
        <DialogContent>
          <Typography id="transfer-success-description" sx={{ mt: 1 }}>
            Your transfer was completed successfully. 🎉
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            variant="contained"
            onClick={onClose}
            sx={{ borderRadius: 3, px: 4, bgcolor: "green" }}
          >
            OK
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
